module.exports = __webpack_public_path__ + "fonts/comfortaa-regular-webfont.d6fccd46.woff2";